// Conectores que uma TRANSPORTADORA pode receber no vínculo (aba admin "Conector").
// O catálogo (GET /catalogo/conectores) lista todos; os de escopo `embarcador`
// (ERPs, PO1-3614) têm vínculo próprio por embarcador e não entram aqui. Sem
// `escopo` (resposta antiga) vale como transportadora, como era antes.
export function conectoresDaTransportadora(conectores) {
  return (Array.isArray(conectores) ? conectores : []).filter((c) => !c || !c.escopo || c.escopo === "transportadora");
}
